import { DefaultButton, DialogFooter, Icon, IconButton, IStackTokens, Label, MessageBar, MessageBarType, Modal, PrimaryButton, Spinner, SpinnerSize, Stack, Text, TextField, Toggle, TooltipHost } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import { add, dismissMessage, get, reset, setStage1, update } from "./FeesFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, DynamicNumberInputField, InputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../repository/Accountant/common_pb";
import { AddFeeRequest, AddFeeResponse, FeeEntry, GetFeeRequest, UpdateFeeRequest, UpdateFeeResponse } from "../../../../repository/Accountant/fee_pb";


let req: AddFeeRequest;
let updateReq: UpdateFeeRequest;

let promise: any;

let org: number = -1;
let current: AuthenticateReply.AsObject;

export const FeesForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();


    const state: { isLoading: boolean, message: ApiMessage | undefined, stage1: any } = useAppSelector((state) => {

        return { isLoading: state.feesForm.isLoading, message: state.feesForm.message, stage1: state.feesForm.stage1 }
    })

    useEffect(() => {
        var l = searchParams.get('org');
        req = new AddFeeRequest();
        updateReq = new UpdateFeeRequest()
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
            }
        }

        if (props.type == FormType.EDIT) {
            if (props.fetchData) {
                let r = new GetFeeRequest()
                r.setId(props?.renderObject?.id);
                promise?.abort()
                promise = dispatch(get({ body: r, headers: getHeaders() }))
            } else {
                dispatch(setStage1(props?.renderObject))
            }
        }


        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])



    return (
        <>

            <Formik
                enableReinitialize={true}
                initialValues={{

                    name: (props.renderObject) ? props.renderObject?.name : '',
                    isAvailable: (props.renderObject) ? props.renderObject.isAvailable : true,
                    isActive: (props.renderObject) ? props.renderObject.isActive : true,
                    extraFields: (state.stage1?.extraFields) ? state.stage1?.extraFields as DynamicField[] : [] as DynamicField[],
                    feeEntries: (state.stage1?.feeEntries) ? state.stage1?.feeEntries as { activationThreshold: string, fixedValue: string, percentageValue: string }[] : [] as { activationThreshold: string, fixedValue: string, percentageValue: string }[],

                }}

                validationSchema={Yup.object({

                    name: inputs.feeName,
                    extraFields: inputs.extraFields,
                    feeEntries: inputs.feeEntries,


                })}

                onSubmit={(values, actions) => {
                    if (props.type == FormType.ADD) {
                        req.setName(values.name.trim());
                        req.setIsavailable(values.isAvailable)
                        req.setIsactive(values.isActive)

                        const feeEntries: FeeEntry[] = [];
                        values.feeEntries.forEach((e) => {
                            const r = new FeeEntry();
                            r.setFixedvalue(e.fixedValue + "");
                            r.setPercentagevalue(e.percentageValue + "")
                            r.setActivationthreshold(e.activationThreshold+ "")
                            feeEntries.push(r)
                        })
                        req.setFeeentriesList(feeEntries)

                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        req.setExtrafieldsList(extraField)
                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: AddFeeResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            id: res.success?.id,
                                            name: values.name.trim(),
                                            isAvailable: values.isAvailable,
                                            isActive: values.isActive,
                                            createdDate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            addedBy: (current.profile?.firstname?.value ?? "") + " " + (current.profile?.lastname?.value ?? ""),
                                            addedById: current.profile?.id?.value,
                                        });
                                    }
                                }
                                actions.setSubmitting(false)


                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {
                        updateReq.setName(values.name.trim());
                        updateReq.setIsavailable(values.isAvailable)

                        const feeEntries: FeeEntry[] = [];
                        values.feeEntries.forEach((e) => {
                            const r = new FeeEntry();
                            r.setFixedvalue(e.fixedValue + "");
                            r.setPercentagevalue(e.percentageValue+ "")
                            r.setActivationthreshold(e.activationThreshold + "")
                            feeEntries.push(r)
                        })
                        updateReq.setFeeentriesList(feeEntries)

                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        updateReq.setExtrafieldsList(extraField)
                        updateReq.setId(props.renderObject?.id)
                        promise = dispatch(update({ body: updateReq, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: UpdateFeeResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            ...props.renderObject,
                                            name: values.name.trim(),
                                            isAvailable: values.isAvailable,
                                            extraFields: values.extraFields,
                                            isActive: values.isActive,
                                            feeEntries: values.feeEntries,

                                        });
                                    }
                                }
                                actions.setSubmitting(false)

                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    }
                }}

            >
                {formkikProps => (
                    <Form >
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }
                            <Field name="name" label={t("feeName")} placeholder={t("feeNameHint")} component={InputField} disabled={state.isLoading} autoFocus maxLength={50} required />

                            {props.type == FormType.ADD ? <Toggle

                                onText={t("active")} offText={t("inactive")}
                                label={t("status")}
                                disabled={state.isLoading}

                                checked={formkikProps.values.isActive}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('isActive', checked);
                                }
                                }
                            /> : undefined}
                            <Toggle

                                onText={t("available")} offText={t("unavailable")}
                                label={t("availability")}
                                disabled={state.isLoading}

                                checked={formkikProps.values.isAvailable}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('isAvailable', checked);
                                }
                                }
                            />


                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("feeEntries") + ' '}
                                    <TooltipHost content={t("feeEntriesDescription")}>
                                        <Icon iconName="Info" aria-label={t("feeEntries")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <FieldArray
                                name="feeEntries"
                                validateOnChange={false}

                            >
                                {arrayHelpers => {
                                    let r = [] as React.ReactNode[];
                                    if (formkikProps.values.feeEntries && formkikProps.values.feeEntries.length > 0) {
                                        r = formkikProps.values.feeEntries.map((o, index) => {
                                            return (
                                                <Stack styles={{ root: { borderRadius: 8, border: "1px solid rgb(153,153,153)" } }} key={index}>
                                                    <Stack.Item align="end">
                                                        <IconButton disabled={state.isLoading}
                                                            iconProps={{ iconName: "remove" }} onClick={() => {
                                                                arrayHelpers.remove(index)
                                                            }} />
                                                    </Stack.Item>
                                                    <Stack tokens={{ childrenGap: props.childrenGap, padding: "0px 20px 20px 20px" }}>
                                                        <Stack.Item grow>
                                                            <Label disabled={state.isLoading}>{
                                                                <div>
                                                                    {t("activationThreshold") + ' '}
                                                                    <TooltipHost content={t("activationThresholdDescription")}>
                                                                        <Icon iconName="Info" aria-label={t("activationThreshold")} />
                                                                    </TooltipHost>
                                                                </div>
                                                            }</Label>
                                                            <DynamicNumberInputField name={`feeEntries[${index}].activationThreshold`} defaultValue={t("activationThresholdHint")} disabled={state.isLoading}
                                                                inputProps={{ autoFocus: (o as any)?.autoFocus }} min={0} step={1} max={999999999999999} />
                                                        </Stack.Item>
                                                        <Stack.Item grow>
                                                            <Label disabled={state.isLoading}>{
                                                                <div>
                                                                    {t("fixedValue") + ' '}
                                                                    <TooltipHost content={t("fixedValueDescription")}>
                                                                        <Icon iconName="Info" aria-label={t("fixedValue")} />
                                                                    </TooltipHost>
                                                                </div>
                                                            }</Label>
                                                            <DynamicNumberInputField name={`feeEntries[${index}].fixedValue`} defaultValue={t("fixedValueHint")} min={0} step={1} max={999999999999999} disabled={state.isLoading}
                                                            />
                                                        </Stack.Item>
                                                        <Stack.Item grow>
                                                            <Label disabled={state.isLoading}>{
                                                                <div>
                                                                    {t("percentageValue") + ' '}
                                                                    <TooltipHost content={t("percentageValueDescription")}>
                                                                        <Icon iconName="Info" aria-label={t("percentageValue")} />
                                                                    </TooltipHost>
                                                                </div>
                                                            }</Label>
                                                            <DynamicNumberInputField name={`feeEntries[${index}].percentageValue`} defaultValue={t("percentageValueHint")} disabled={state.isLoading}
                                                                min={0} step={1} max={100}
                                                            />
                                                        </Stack.Item>

                                                    </Stack>
                                                </Stack>
                                            )
                                        }
                                        )
                                    }
                                    if (formkikProps.values.feeEntries.length <= 20) {
                                        r.push(< IconButton disabled={state.isLoading}
                                            key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ activationThreshold: 0, fixedValue: 0, percentageValue: 0, autoFocus: true })
                                            }} />)
                                    }
                                    return r;
                                }
                                }

                            </FieldArray>



                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("extraFields") + ' '}
                                    <TooltipHost content={t("extraInformationDescription")}>
                                        <Icon iconName="Info" aria-label={t("extraFields")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <FieldArray
                                name="extraFields"
                                validateOnChange={false}

                            >
                                {arrayHelpers => {
                                    let r = [] as React.ReactNode[];
                                    if (formkikProps.values.extraFields && formkikProps.values.extraFields.length > 0) {
                                        r = formkikProps.values.extraFields.map((o, index) => {
                                            if (o.type == 1) {
                                                return (<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: props.childrenGap }} key={index}>
                                                    {o.label != undefined ? <Stack.Item grow> <DynamicInputField name={`extraFields[${index}].label`} placeholder={t("extraFieldLabel")} disabled={state.isLoading}
                                                        maxLength={50} autoFocus={(o as any)?.autoFocus} /> </Stack.Item> : null}
                                                    <Stack.Item grow>  <DynamicInputField name={`extraFields[${index}].value`} placeholder={t("extraFieldValue")} disabled={state.isLoading}
                                                        maxLength={50}
                                                    /></Stack.Item>

                                                    <IconButton disabled={state.isLoading}
                                                        iconProps={{ iconName: "remove" }} onClick={() => {
                                                            arrayHelpers.remove(index)
                                                        }} />
                                                </Stack>)
                                            }
                                        }
                                        )
                                    }
                                    if (formkikProps.values.extraFields.length <= 4) {
                                        r.push(< IconButton disabled={state.isLoading}
                                            key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ key: (formkikProps.values.extraFields.length + 1) + "", label: "", type: 1, value: "", autoFocus: true })
                                            }} />)
                                    }
                                    return r;
                                }
                                }

                            </FieldArray>
                        </Stack>
                        <DialogFooter>
                            <PrimaryButton disabled={state.isLoading} text={state.isLoading ? undefined : props.type == FormType.ADD ? t("add") : t("edit")} type="submit" >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>

                    </Form>
                )}
            </Formik>
        </>
    );

}

